import { siteConfig } from '@/mocks/site';

const stats = [
  { value: '128万+', label: '注册会员', icon: 'ri-user-heart-line', color: 'primary' },
  { value: '5.6万+', label: '优质文章', icon: 'ri-article-line', color: 'accent' },
  { value: '8.6万', label: '日活跃用户', icon: 'ri-flashlight-line', color: 'secondary' },
  { value: '12个', label: '兴趣分类', icon: 'ri-stack-line', color: 'primary' },
];

const colorClasses: Record<string, { bg: string; text: string }> = {
  primary: { bg: 'bg-primary-50', text: 'text-primary-500' },
  accent: { bg: 'bg-accent-50', text: 'text-accent-500' },
  secondary: { bg: 'bg-secondary-50', text: 'text-secondary-500' },
};

export default function CommunityStats() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            社区数据一览
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            撸撸社自{siteConfig.foundingYear}年成立以来，不断汇聚热爱生活的朋友，用数据见证我们的成长。
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {stats.map((stat) => {
            const c = colorClasses[stat.color] || colorClasses.primary;
            return (
              <div key={stat.label} className="text-center p-6 rounded-lg bg-background-100">
                <div className={`w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full ${c.bg}`}>
                  <i className={`${stat.icon} text-xl ${c.text}`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-foreground-500">
                  {stat.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}